import React from 'react';
import {connect} from 'react-redux';
import mapDispatch from '~/misc/mapDispatch';
import cs from 'classnames'
import css from './index.css'
import Button from '~/components/common/Button';
import {modalClose, modalChange} from '~/modules/modal/actions';
import * as modes from '~/modules/modal/modes';
import Upload from '~/components/pages/MyAccount/BidVerfiy/component/upload';
import { uploadW9form, uploadInfoForLoadsmart} from '~/modules/user/actions';
import { confirmBid } from '~/modules/bids/actions'
import { createBookDynamic } from "~/modules/bookings/action"


const confirmBox = ({allHasFile, submit, confirmSelect, confirm}) => {
  const disabled = (!allHasFile || !confirm);
  return (
    <div>
      <div className={css.confirmWarp} onClick={confirmSelect}>
        <div className={cs({
          [css.select]: !confirm,
          [css.selected]: confirm
        })}></div>
        <div className={css.confirmMessage}>By ticking this box, you agree with us to send your documents to Loadsmart for the onboarding purpose.</div>
      </div>
      <footer className={css.bookingFooter}>
        <div className={css.bookingFooterRow}>
          <Button mods={['action']} onClick={submit} disabled={ disabled }  className={cs({[css.uploaderBtn]: !disabled, [css.uploaderBtnDisabled]: disabled})}>Submit</Button>
        </div>
      </footer>
    </div>
  )
}


const confirmButton = ({ confirmSelect, confirm, submit }) => {
  return (
    <div>
      <div className={cs(css.confirmWarp,css.confirmWarpSingle)} onClick={confirmSelect}>
        <div className={cs({
          [css.select]: !confirm,
          [css.selected]: confirm
        })}></div>
        <div className={css.confirmMessage}>By ticking this box, you agree with us to send your documents to Loadsmart for the onboarding purpose.</div>
      </div>
      <footer className={css.bookingFooter}>
        <div className={css.bookingFooterRow}>
          <Button mods={['action']} onClick={submit} disabled={ !confirm }  className={css.uploaderBtn}>Submit</Button>
        </div>
      </footer>
    </div>
  )
}

class LoadsmartOnboard extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      id: '',
      token: '',
      nextNode: '',
      confirm: false
    }
  }
  componentWillMount() {
    const { context:  { verifyUrl }} = this.props;
    const queryString = verifyUrl.replace(/^.+?\?/, '');
    const query = new URLSearchParams(queryString);
    const id = query.get('id');
    const token = query.get('token');
    const nextNode = query.get("nextNode");
    const type = query.get("operation");
    const shipment = query.get("shipmentId");
    const isAuto = query.get("page") === "auto_upload";
    this.setState({
      id,
      token,
      nextNode,
      type,
      shipment,
      isAuto
    })
  }
  confirmSelect = () => {
    this.setState({
      confirm: !this.state.confirm
    })
  }

  uploadImg = (file) => {
    const { id, token } = this.state;
    const { uploadImg } = this.props;
    return uploadImg({
      id,
      token,
      file,
    })
  }
  popupStatus = (handler) => {
    const { showBidPending, showBookPending  } = this.props
    const { type } = this.state
    handler.then(()=> {
      if(type === "bid") {
        showBidPending()
      }else if(type === "book") {
        showBookPending()
      }
    }).catch(error=> {
      window.alert("Upload failed, please try again.")
    })
  }
  autoAction = () => {
    const { type, shipment,nextNode } = this.state;
    const { makeBidDynamic, createBookDynamic } = this.props;
    switch (type) {
      case "bid":
        return this.popupStatus(makeBidDynamic({
          shipmentId: shipment,
        }))
      case "book": 
        return this.popupStatus(createBookDynamic({
          shipmentId: shipment,
          nextNode
        }))
      default:
        throw new Error({
          message: "Unexpect Type"
        })
    }
  }

  uploadInfo = (pics) => {
    const { id, token } = this.state;
    const { uploadInfo } = this.props;
    const { companyName, legalName, phone, mc, dot, authority } = this.props.user
    const files = {
      info: {
        companyName, legalName, phone, mc, dot, authority 
      },
      ...pics
    }
    return uploadInfo({
      id,
      token,
      files,
    }).then((res)=> {
      const { code } =  res;
      if(code !== 200) throw new Error();
      this.autoAction();
    }).catch(()=> {
      window.alert("Upload failed, please try again.")
    })
  } 
  render() {
    const { confirm,isAuto  } = this.state
    return (
      <div className={css.popwrap}>
        <div className={css.bookingNoScroll}>
          <header className={css.bookingTitle}>
            <p>Get Onboarded with Loadsmart.</p>
          </header>
        </div>
        
        <div className={css.bookingScroll}>
          <div className={css.logoWarp}>
            <div className={css.loadsmartLogo}></div>
          </div>
          <main className={css.bookingMainNormal}>
            This is a load from our partner broker Loadsmart. You are required to submit your Operating Authority, Insuarnace Certificate & W9 form to Loadsmart to get onboarded.
          </main>
          <div className={css.uploadWarp}>
          {
            isAuto ? 
            confirmButton({confirm, confirmSelect: this.confirmSelect, submit:this.autoAction})
            :<Upload
              uploadImg = {this.uploadImg}
              uploadInfo = {this.uploadInfo}
              addition = {(arg)=>confirmBox({...arg, confirm, confirmSelect: this.confirmSelect})}
            ></Upload>
          }
          </div>
        </div>
      </div>
    )
  }
}

export default connect(({user})=>{
  return {
    user
  }
}, mapDispatch({
  closePop: () => modalClose(modes.LOADSMART_ONBOARD),
  uploadImg: (props, {id, token, file}) => uploadW9form(id, token, file),
  uploadInfo: (props, {id, token, files}) => uploadInfoForLoadsmart (id, token, files),
  makeBidDynamic: (props, {shipmentId}) => confirmBid(shipmentId),
  createBookDynamic: (props, {shipmentId, nextNode}) => createBookDynamic(shipmentId, nextNode),
  showBidPending: (props, data) => modalChange(modes.PENDING, {type: 'askPop', pendingType:"loadsmartBid"}),
  showBookPending: (props, data) => modalChange(modes.PENDING, {type: 'askPop', pendingType:"loadsmartBook"}),
}))(LoadsmartOnboard);


// WEBPACK FOOTER //
// ./src/components/Popup/LoadsmartOnboard/index.js